import { Accordion, Stack, StackItem, Typography } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import { CenteredImage } from "@/components/molecules"
import { CUSTOMER_SERVICE_PHONE } from "@/features/customer-service"
import { EnergyType } from "@/features/subscription"
import { NextIntlRichText } from "@/features/translations"
import { METER_POINT_ID_LENGTH } from "../../constants/meterPointLength"

const PRM_LOCALISATION_SRC = "/assets/images/illustrations/prm-localisation.svg"
const PCE_BILL_SRC = "/assets/images/illustrations/pce-bill.svg"

type MeterPointAccordionProps = {
    energyType: EnergyType
}

export function MeterPointAccordion({ energyType }: MeterPointAccordionProps) {
    const t = useTranslations("MeterPointAccordion")

    return (
        <Accordion
            theme="base500"
            headingLevel="h4"
            title={t(`${energyType}.title`)}
        >
            <Stack
                flexDirection="column"
                gap="lg"
            >
                <StackItem>
                    <Typography>
                        <NextIntlRichText>
                            {(tags) =>
                                t.rich(`${energyType}.description`, {
                                    length: METER_POINT_ID_LENGTH,
                                    ...tags,
                                })
                            }
                        </NextIntlRichText>
                    </Typography>
                </StackItem>
                <StackItem>
                    <Typography>{t(`${energyType}.text1`)}</Typography>
                    <Typography>{t(`${energyType}.text2`)}</Typography>
                    <Typography>
                        {t(`${energyType}.text3`, { phoneNumber: CUSTOMER_SERVICE_PHONE })}
                    </Typography>
                </StackItem>
                <StackItem>
                    <CenteredImage
                        src={
                            energyType === EnergyType.Electricity
                                ? PRM_LOCALISATION_SRC
                                : PCE_BILL_SRC
                        }
                        alt={t(`${energyType}.imageAlt`)}
                        height={150}
                        width={300}
                    />
                </StackItem>
            </Stack>
        </Accordion>
    )
}

MeterPointAccordion.messages = ["MeterPointAccordion"] as const
